/** No ordinary web/native runtime may connect to the dedicated purge project. */
export function assertApplicationProject(projectId: string) {
  if (projectId === 'urakka-purge-staging') {
    throw new Error('APPLICATION_RUNTIME_FORBIDDEN_IN_PURGE_PROJECT');
  }
}
